import { memo, type FC } from "react";
import dynamic from "next/dynamic";
import { getImageAltTag } from "@lib/utils/attributesUtils";
import { Flex } from "@ecco/ui/flex";
import { ProductImageThumbnail } from "./ProductImageThumbnail";
import type { ProductMedia } from "@lib/product/types";

const ProductVideoThumbnail = dynamic(
    () => import("./ProductVideoThumbnail").then((mod) => mod.ProductVideoThumbnail),
    { ssr: false }
);
import { useFibblState } from "@components/fibbl/FibblProvider";
import { FIBBL_INDEX, isFibblEnabled } from "@components/fibbl/constants";

interface IProductImagesThumbnailProps {
    media: ProductMedia[];
    setImageIndex: (index: number) => void;
    altTagPattern?: string;
    imageIndex: number;
}

export const ProductImagesThumbnails: FC<IProductImagesThumbnailProps> = memo(
    ({ media, setImageIndex, altTagPattern, imageIndex }) => {
        const { isFibblReady } = useFibblState();
        const showIcon = (i: number) => isFibblEnabled && isFibblReady && i === FIBBL_INDEX;
        return (
            <Flex
                w="100%"
                maxW={"10.4"}
                h="auto"
                position="sticky"
                top={16}
                left={5}
                flexDir={"column"}
                gap={0.5}
            >
                {media.map((m, i) => {
                    return m.type === "video" || m.type === "interactiveVideo" ? (
                        <ProductVideoThumbnail
                            key={m.url}
                            index={i}
                            currentlySelected={imageIndex === i}
                            media={m}
                            setImageIndex={setImageIndex}
                        />
                    ) : (
                        <ProductImageThumbnail
                            key={m.url}
                            index={i}
                            currentlySelected={imageIndex === i}
                            media={m}
                            alt={getImageAltTag(altTagPattern, m.label)}
                            setImageIndex={setImageIndex}
                            overlay={showIcon(i) ? "3d-image" : undefined}
                        />
                    );
                })}
            </Flex>
        );
    }
);

ProductImagesThumbnails.displayName = "ProductImagesThumbnails";

export default ProductImagesThumbnails;
